// ----------------- UPDATE PREVIOUS LOCATION -----------------
export const UPDATE_PREVIOUS_LOCATION = 'UPDATE_PREVIOUS_LOCATION';
